import React, { useState, useEffect } from 'react';
import { prospectApi, userApi } from '../../services/consts';
// import { userApi } from '../../services/consts';
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Card,
    CardTitle,
    CardBody,
    Row,
    Col
} from 'reactstrap';
import { tokenHeader, getUserToken, getCurrentUser } from "../../services/user-service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const apiEndPoint = prospectApi;
const apiUser = userApi;
const AddProspect = (props) => {

    const [loaded, setLoaded] = useState(false);
    const [users, setUsers] = useState([]);
    const [currentUserName, setCurrentUserName] = useState('');

    var callbackSuccess = (result) => {
        // console.log(JSON.stringify(result));
        setUsers(result);
    }
    var callbackError = (error) => {
        // console.log("Error:");
    }
    useEffect((e) => {
        // console.log(e);
        if (!loaded) {
            setLoaded(true);
            fetch(apiUser, {
                headers: {
                    [tokenHeader]: getUserToken()
                }
            })
                .then(res => res.json())
                .then(callbackSuccess, callbackError)
        }
        getCurrentUser().then((result) => {
            if (result != null) {
                // setEmail(result.email);
                setCurrentUserName(result.name);
            }
        })
    });

    const [inputList, setInputListEmailTo] = useState([{to: ""}]);
    const [inputListCC, setInputListEmailCC] = useState([{ cc: ""}]);
    const [id, setId] = useState(0);
    const [name, setName] = useState('');
    const [company, setCompany] = useState('');
    const [email, setEmail] = useState([]);
    const [city, setCity] = useState('');
    const [website, setWebsite] = useState('');
    const [socialmedia, setSocialMedia] = useState('');
    const [aboutCompany, setAboutCompany] = useState('');
    const [companyScope, setCompanyScope] = useState('');
    const [state, setState] = useState('');
    const [country, setCountry] = useState('');
    const [mobile, setMobile] = useState('');
    const [phones, setPhones] = useState('');
    const [type, setType] = useState('');
    const [industry, setIndustry] = useState('');
    // const [leadId, setLeadId] = useState('');
    const [leadBy, setLeadBy] = useState('');
    const [status, setStatus] = useState('Open');
    // const [assignedId, setAssignedId] = useState('');
    const [assignedUser, setAssignedUser] = useState('');
    const [fetched, setFetched] = useState(false);
    const [label, setLabel] = useState('Add Prospect');
    const [prospectIsValid, setProspectIsValid] = useState(false);
    const [companyIsValid, setCompanyIsValid] = useState(false);
    const [mobileEmailIsValid, setMobileEmailIsValid] = useState(false);
    // const [mobileIsValid, setMobileIsValid] = useState(false);

    var doCancel = () => {
        props.history.push('/prospects');
    }

    useEffect(() => {
        if (props.match.params.id != undefined && !fetched) {
            setFetched(true);
            setLabel('Update Prospect');
            fetch(apiEndPoint + "/" + props.match.params.id, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    [tokenHeader]: getUserToken()
                }
            })
                .then(res => res.json())
                .then(function (result) {
                    // console.log("result",result.mobile);
                    setId(result.id);
                    setName(result.name);
                    setCompany(result.company);
                    // setEmail(result.email);
                    setInputListEmailTo(result.emailTO);
                    setInputListEmailCC(result.emailCC);
                    setCity(result.city);
                    setState(result.state);
                    setCountry(result.country);
                    setMobile(result.mobile);
                    setPhones(result.phones);
                    setType(result.type);
                    setIndustry(result.industry);
                    setWebsite(result.website)
                    setSocialMedia(result.socialMediaLink)
                    setAboutCompany(result.aboutCompany)
                    setCompanyScope(result.companyScope)
                    // setLeadId(result.leadId);
                    setLeadBy(result.leadBy);
                    setStatus(result.status);
                    // setAssignedId(result.assignedId);
                    setAssignedUser(result.assignedUser);
                    // console.log(JSON.stringify(result));
                })
        }
    })

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][['to']] = value;
    setInputListEmailTo(list);
  };

  const handleRemoveClick = index => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputListEmailTo(list);
  };

  const handleAddClick = () => {
    setInputListEmailTo([...inputList,{ to: ""}]);
  };

  const handleInputChangeCC = (e, index) => {
    const { name, value } = e.target;
    const listCC = [...inputListCC];
    listCC[index]['cc'] = value;
    setInputListEmailCC(listCC);
  };

  const handleRemoveClickCC = index => {
    const listCC = [...inputListCC];
    listCC.splice(index, 1);
    setInputListEmailCC(listCC);
  };

  const handleAddClickCC = () => {
    setInputListEmailCC([...inputListCC, { cc: ""}]);
  };

    // let toEmail = [];
    var addProspect = (e) => {
        e.preventDefault();
        let methodType = 'post';
        // for(let i=0 ; i<inputList.length ; i++){
        //     toEmail[i] = inputList[i].to
        // }
        var prospect = {
            name: name,
            company: company,
            emailTO: inputList,
            emailCC: inputListCC,
            city: city,
            state: state,
            country: country,
            mobile: mobile == "" ? null : mobile,
            phones: phones,
            type: type == null || type == "" || type == undefined ? 'other' : type,
            industry: industry,
            // leadUserId: leadId,
            leadBy: leadBy == null || leadBy == "" || leadBy == undefined ? currentUserName : leadBy,
            status: status,
            // assignedUserId: assignedId,
            assignedUser: assignedUser == null || assignedUser == "" || assignedUser == undefined ? currentUserName :assignedUser,
            website: website,
            socialMediaLink: socialmedia,
            aboutCompany: aboutCompany,
            companyScope: companyScope
        };
        if (prospect.name == '') {
            toast.error('Name is required');
            return setProspectIsValid(true);
        } else if (prospect.company == '') {
            toast.error('Company is required');
            return setCompanyIsValid(true);
        } else if ((prospect.mobile == '' && prospect.emailTO[0].to == '') || (prospect.mobile == null && prospect.emailTO[0].to == null) || (prospect.mobile == null && prospect.emailTO[0].to == '') ) {
            toast.error('Mobile or Email is required');
            return setMobileEmailIsValid(true);
        }
        if (id != 0) { //to update
            methodType = 'put';
            prospect.id = id;
        }
        fetch(apiEndPoint, {
            method: methodType,
            body: JSON.stringify(prospect),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                [tokenHeader]: getUserToken()
            }
        }).then(function (result) {
            if(result.status !== 500){
            // console.log("Prospect added.");
            toast.success('Prospect added');
            setTimeout(() => {
                props.history.push('/prospects');
            }, 1000);
            }
            else{
            toast.error('Something went wrong');
            }
        })
    };
    var onHandleChange = (e) => {
        // console.log("e.target.name:" + e.target.name);
        if (e.target.name == 'name') {
            setName(e.target.value);
        } else if (e.target.name == 'company') {
            setCompany(e.target.value);
        }
        //  else if (e.target.name == 'email') {
        //     setEmail(e.target.value);
        // } 
        else if (e.target.name == 'website') {
            setWebsite(e.target.value);
        }
        else if (e.target.name == 'socialMediaLink') {
            setSocialMedia(e.target.value);
        }
        else if (e.target.name == 'aboutCompany') {
            setAboutCompany(e.target.value);
        }
        else if (e.target.name == 'companyScope') {
            setCompanyScope(e.target.value);
        }
        else if (e.target.name == 'city') {
            setCity(e.target.value);
        } else if (e.target.name == 'state') {
            setState(e.target.value);
        } else if (e.target.name == 'country') {
            setCountry(e.target.value);
        } else if (e.target.name == 'mobile') {
            if(e.target.value.length > 1){
                setMobile(e.target.value);
            }else{
                setMobile(null);
            }
        } else if (e.target.name == 'phones') {
            setPhones(e.target.value);
        } else if (e.target.name == 'type') {
            setType(e.target.value);
        } else if (e.target.name == 'industry') {
            setIndustry(e.target.value);
        }
        // else if (e.target.name == 'leadId') {
        //     setLeadId(e.target.value);
        // }
        else if (e.target.name == 'leadBy') {
            setLeadBy(e.target.value);
        } else if (e.target.name == 'status') {
            setStatus(e.target.value);
        }
        // else if (e.target.name == 'assignedId') {
        //     setAssignedId(e.target.value);
        // } 
        else if (e.target.name == 'assignedUser') {
            setAssignedUser(e.target.value);
        }
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="mdi mdi-account-multiple-plus mr-2"> </i>
                    {label}
                </CardTitle>
                <CardBody className="">
                    <Form>
                    <Row>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>Prospect Name</Label>
                            <Input type="text" onChange={onHandleChange} value={name} name="name" id="name" placeholder="Prospect Name" />
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>Company Name</Label>
                            <Input type="text" onChange={onHandleChange} value={company} name="company" id="company" placeholder="Company Name" />
                        </FormGroup>
                        </Col>
                        </Row>
                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>Website Link</Label>
                            <Input type="text" onChange={onHandleChange} value={website} name="website" id="website" placeholder="Website Link" />
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>Social Media Link (Optional)</Label>
                            <Input type="text" onChange={onHandleChange} value={socialmedia} name="socialMediaLink" id="socialMediaLink" placeholder="Social Media Link" />
                        </FormGroup>
                        </Col>
                        </Row>
                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>Designation</Label>
                            <Input type="textarea" onChange={onHandleChange} value={aboutCompany} name="aboutCompany" id="aboutCompany" placeholder="Designation" />
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>Company Scope</Label>
                            <Input type="textarea" onChange={onHandleChange} value={companyScope} name="companyScope" id="companyScope" placeholder="Company Scope Details" />
                        </FormGroup>
                        </Col>
                        </Row>
                        <Row>
                        <Col xl={6}>
                        {inputList.map((x, i) => {
                            return(
                        <FormGroup key={i} >
                            <Label>Email (To)</Label>
                            <Input style={{marginBottom:"10px"}} type="email" onChange={e => handleInputChange(e, i)} value={x.to} name="email" id="email" placeholder="Email"/>
                        <div className="btn-box">
                            {inputList.length !== 1 && <Button style={{marginLeft:"10px"}}
                                className="btn-icon btn-2 btn-sm" color="danger" type="button"
                                onClick={() => handleRemoveClick(i)}>
                                    <i className="fas fa-times" />
                                    </Button>}
                            {inputList.length - 1 === i && <Button style={{marginLeft:"10px"}} className="btn-icon btn-2 btn-sm" color="success" type="button" onClick={handleAddClick}>
                            <i className="fas fa-plus" />
                                </Button>}
                            </div>
                        </FormGroup>
                        )})}
                        </Col>
                        <Col xl={6}>
                        {inputListCC.map((x, i) => {
                            return(
                        <FormGroup key={i}>
                            <Label>Email (CC)</Label>
                            <Input style={{marginBottom:"10px"}} type="email" onChange={e => handleInputChangeCC(e, i)} value={x.cc} name="email" id="email" placeholder="Email" />
                        <div className="btn-box">
                            {inputListCC.length !== 1 && <Button style={{marginLeft:"10px"}}
                                className="btn-icon btn-2 btn-sm" color="danger" type="button"
                                onClick={() => handleRemoveClickCC(i)}>
                                    <i className="fas fa-times" />
                                    </Button>}
                            {inputListCC.length - 1 === i && <Button style={{marginLeft:"10px"}} className="btn-icon btn-2 btn-sm" color="success" type="button" onClick={handleAddClickCC}>
                            <i className="fas fa-plus" />
                                </Button>}
                            </div>
                        </FormGroup>
                        )})}
                        </Col>
                        </Row>
                        <Row>
                        <Col xl={4}>
                        <FormGroup>
                            <Label>City</Label>
                            <Input type="text" onChange={onHandleChange} value={city} name="city" id="city" placeholder="City" />
                        </FormGroup>
                        </Col>
                        <Col xl={4}>
                        <FormGroup>
                            <Label>State</Label>
                            <Input type="text" onChange={onHandleChange} value={state} name="state" id="state" placeholder="State" />
                        </FormGroup>
                        </Col>
                        <Col xl={4}>
                        <FormGroup>
                            <Label>Country</Label>
                            <Input type="text" onChange={onHandleChange} value={country} name="country" id="country" placeholder="Country" />
                        </FormGroup>
                        </Col>
                        </Row>
                        <Row>
                            <Col xl={6}>
                        <FormGroup>
                            <Label>Mobile No</Label>
                            <Input type="number" onChange={onHandleChange} value={mobile} name="mobile" id="mobile" placeholder="Mobile No" maxLength="10" />
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        {/* <FormGroup>
                            <Label>Phones</Label>
                            <Input type="number" onChange={onHandleChange} value={phones} name="phones" id="phones" placeholder="Phone Number" />
                        </FormGroup> */}
                        <FormGroup>
                            <Label>Industry</Label>
                            <Input type="select" onChange={onHandleChange} value={type} name="type" id="type">
                                <option>Pharmaceuticals</option>
                                <option>Nutra</option>
                                <option>Food</option>
                                <option>other</option>
                            </Input>
                        </FormGroup>
                        </Col>
                        </Row>
                        <FormGroup>
                            <Label>Notes</Label>
                            <Input type="text" onChange={onHandleChange} value={industry} name="industry" id="industry" placeholder="Add note..." />
                        </FormGroup>
                        {/* <FormGroup>
                            <Label>Lead ID</Label>
                            <Input type="select" onChange={onHandleChange} value={leadId} name="leadId" id="leadId">
                                <option hidden>Lead ID</option>
                                {users.map(item => (
                                    <option key={item.id}>{item.id}</option>
                                ))}
                            </Input>
                        </FormGroup> */}
                        <Row>
                            <Col xl={4}>
                                <FormGroup>
                                <Label>Lead By</Label>
                                <Input type="select" onChange={onHandleChange} value={leadBy} name="leadBy" id="leadBy">
                                    <option hidden>{currentUserName}</option>
                                    {users.map(item => (
                                        <option key={item.id}>{item.name}</option>
                                    ))}
                                </Input>
                                </FormGroup>
                            </Col>
                            
                            <Col xl={4}>
                                <FormGroup>
                                <Label>Status</Label>
                                <Input type="select" onChange={onHandleChange} value={status} name="status" id="status">
                                    <option>Open</option>
                                    <option>Follow up</option>
                                    <option>Leads</option>
                                    <option>Trail</option>
                                    <option>Customer</option>
                                </Input>
                                </FormGroup>
                            </Col>

                            <Col xl={4}>
                                <FormGroup>
                                <Label>Assigned User</Label>
                                <Input type="select" onChange={onHandleChange} value={assignedUser} name="assignedUser" id="assignedUser">
                                    <option hidden value={currentUserName}>{currentUserName}</option>
                                    {users.map(item => (
                                        <option key={item.id}>{item.name}</option>
                                    ))}
                                </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        {/* <FormGroup>
                            <Label>Assigned ID</Label>
                            <Input type="select" onChange={onHandleChange} value={assignedId} name="assignedId" id="assignedId">
                                <option hidden>Assigned ID</option>
                                {users.map(item => (
                                    <option key={item.id}>{item.id}</option>
                                ))}
                            </Input>
                        </FormGroup> */}
                        <Button color="success" onClick={addProspect}>{label}</Button>&nbsp;&nbsp;&nbsp;
                        <Button type="btn btn-secondary" onClick={doCancel}>Cancel</Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
}

export default AddProspect;